export const MENU_EXPEDIENTE_PERSONAL = {
  DATOS_GENERALES: 1,
  REFERENCIAS: 2,
  DOCUMENTOS: 3,
  DESARROLLO_ELEMENTO: 4,
  PUESTO_DEPENDENCIA: 5,
  RESULTADOS_C3: 6,
  LINEA_TIEMPO: 7,
  TRAMITES_ADMINISTRATIVOS: 8,
  MEDIA_FILIACION: 9,
  EVALUACIONES: 10,
  CARRERA_POLICIAL: 11,
  TRAYECTORIA_LABORAL: 12,
  LOCS: 13,
}
